import { EMAIL_PATTERN } from '@psyomics/ui-common';
import { isValidPhoneNumber, type CountryCode } from 'libphonenumber-js';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useValidateEmailOrPhone = (countryCode: CountryCode = 'GB') => {
  const { t } = useTranslation();
  const validate = useCallback(
    (value: string) => {
      return (
        EMAIL_PATTERN.test(value) || isValidPhoneNumber(value, countryCode) || t('auth.common.errors.usernameInvalid')
      );
    },
    [t, countryCode]
  );
  return validate;
};

export { useValidateEmailOrPhone };
